module.exports = __webpack_public_path__ + "img/zsbank.24608720.png";